import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import PasswordField from "@/components/input/PasswordField.vue";
import { InputRules } from "@/rules";
import { useApi } from "@/plugins/api/api";
import { useAlert } from "@/plugins/alert/alert";

type Emits = {
  (e: "submit"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralUserPasswordDialog',
  emits: ["submit"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const { Paths, $post } = useApi();
const { $alert } = useAlert();



const length = 50;

const isOpen = ref(false);
const password = ref("");
const vform = ref();

const onClose = () => {
  isOpen.value = false;
};
const onSubmit = async () => {
  if (!vform.value?.validate()) return;
  const result = await $post(`${Paths.userMaster.general}/${password.value}`);
  if (result) {
    $alert("success", "パスワードの変更に成功しました。");
    emits("submit");
    onClose();
  }
};

watch(isOpen, val => {
  if (val) vform.value?.reset();
});

return { __sfc: true,Paths, $post, $alert, emits, length, isOpen, password, vform, onClose, onSubmit, PasswordField, InputRules }
}

})